import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'

Vue.use(InfiniteLoading, {
  props: {
    spinner: 'circles',
    forceUseInfiniteWrapper: true,
    distance: 200
    /* other props need to configure */
  },
  system: {
    throttleLimit: 200
    /* other settings need to configure */
  },
  slots: {
    noResults: '没有结果~',
    noMore: '已经到底了~', // you can pass a string value
    error: '加载出错~' // you can pass a string value
    // error: InfiniteError, // you also can pass a Vue component as a slot
  }
})
